export const mutationTypes = {
  CREATE_TOAST: 'CREATE_TOAST',
  DELETE_TOAST: 'DELETE_TOAST',

  UPDATE_EVALUATION_VIEW_TYPE: 'UPDATE_EVALUATION_VIEW_TYPE',
}

export default {
  [mutationTypes.CREATE_TOAST](state, payload) {
    state.toasts.unshift(payload)
  },

  [mutationTypes.DELETE_TOAST](state, payload) {
    const item = state.toasts.filter(toast => toast.id !== payload)
    state.toasts = [...item]
  },

  [mutationTypes.UPDATE_EVALUATION_VIEW_TYPE](state, payload) {
    state.evaluationViewType = payload
  },
}
